export const journalPapers = [
    {
        title: 'Non-Invasive Detection of Coronary Artery Disease Using Wearable Vest with Integrated Phonocardiogram Sensors.',
        detail: 'Fynn, M., Marocchi, M., Rashid, J., Rong, Y., Saha, G., Mandana, K. J. Vasc. Dis., 5, 11.',
        venue: 'Journal of Vascular Diseases',
        year: '2026',
        link: 'https://doi.org/10.3390/jvd5020011'
    },
    {
        title: 'Scaling to Multimodal and Multichannel Heart Sound Classification: Fine-Tuning Wav2Vec 2.0 with Synthetic and Augmented Biosignals.',
        detail: 'Marocchi, M., Fynn, M., Mandana, K., Rong, Y. Available on arXiv.',
        venue: 'Preprint',
        year: '2025',
        link: 'https://arxiv.org/abs/2509.11606'
    },
    {
        title: 'Generative Deep Learning and Signal Processing for Data Augmentation of Cardiac Auscultation Signals: Improving Model Robustness Using Synthetic Audio.',
        detail: 'Abbott, L., Marocchi, M., Fynn, M., Rong, Y., Nordholm, S. Biomedical Signal Processing and Control, 112, 108469.',
        venue: 'Biomedical Signal Processing and Control',
        year: '2026',
        featuredOrder: 2,
        link: 'https://doi.org/10.1016/j.bspc.2025.108469'
    },
    {
        title: 'Abnormal Heart Sound Classification and Model Interpretability: A Transfer Learning Approach with Deep Learning.',
        detail: 'Marocchi, M., Abbott, L., Rong, Y., Nordholm, S., Dwivedi, G. J. Vasc. Dis., 2, 438-459.',
        venue: 'Journal of Vascular Diseases',
        year: '2023',
        featuredOrder: 1,
        link: 'https://doi.org/10.3390/jvd2040034'
    }
];

export const conferencePapers = [
    {
        title: 'Waveform-Domain Acoustic Style Transfer for Underwater Diver Speech Recognition.',
        detail: 'Marocchi, M., Fynn, M., Rong, Y. International Conference on Green Energy, Computing and Intelligent Technology 2026 (Best Paper Award, Track 6: Intelligent Systems and Sensors).',
        venue: 'GEn-CITy', year: '2026'
    },
    {
        title: 'Noise-Robust Contrastive Learning with an MFCC-Conformer for Coronary Artery Disease Detection.',
        detail: 'Marocchi, M., Fynn, M., Rong, Y. ICASSP 2026, Barcelona, Spain.',
        venue: 'IEEE ICASSP', year: '2026', link: 'https://arxiv.org/abs/2601.18295'
    },
    {
        title: 'Multistage Fusion Framework for Coronary Artery Disease Detection from Multichannel PCG.',
        detail: 'Maity, A., Sinha, S., Fynn, M., Marocchi, M., Mandana, K., Rong, Y., Saha, G. Pattern Recognition and Machine Intelligence 2025.',
        venue: 'PReMI', year: '2025', link: 'https://doi.org/10.1007/978-3-032-18480-1_17'
    },
    {
        title: 'Fine-Tuning of Wav2Vec 2.0 for Multimodal Classification of Abnormal Heart Sounds.',
        detail: 'Marocchi, M., Fynn, M., Rong, Y. Engineering in Medicine and Biology Conference 2025.',
        venue: 'IEEE EMBC', year: '2025', link: 'https://ddfe.curtin.edu.au/yurong/EMBC_Marocchi.pdf'
    },
    {
        title: 'Non-Invasive Detection of Coronary Artery Disease and Valvular Disorders Using a Multichannel PCG Vest.',
        detail: 'Fynn, M., Marocchi, M., Maity, A., Mandana, K., Rashid, J., Rong, Y., Saha, G. EMBC 2025 Student Paper Competition Finalist.',
        venue: 'IEEE EMBC', year: '2025', link: 'https://ddfe.curtin.edu.au/yurong/EMBC_Fynn.pdf'
    },
    {
        title: 'Diffusion-Based Conditional Phonocardiogram Generation: Multichannel Audio from a Single Channel Source.',
        detail: 'Marocchi, M., Abbott, L., Fynn, M., Rong, Y., Mandana, K. Australian Biomedical Engineering Conference 2024.',
        venue: 'ABEC', year: '2024', link: 'https://ddfe.curtin.edu.au/yurong/EPSM24.pdf'
    },
    {
        title: 'Exploring Data and Model Embeddings with EmbedLens: A Plug-and-Play Visualisation Tool.',
        detail: 'Marocchi, M., Walters, H. Australian Data Science Network Conference 2024.',
        venue: 'ADSN', year: '2024', link: 'https://australiandatascience.net/wp-content/uploads/2025/04/ADSN2024_Conference_Proceedings.pdf'
    }
];

export const githubProjects = [
    {
        title: 'Sigwire', meta: 'Signal Analysis / Research Platform', updated: 'Updated Jun 2026',
        url: 'https://github.com/MilanMarocchi/sigwire',
        description: 'A signal analysis research platform for exploring, inspecting, and wiring together signal-processing workflows.',
        visual: 'analyzer', label: 'SIG'
    },
    {
        title: 'Teensy NAM Pedal', meta: 'C / Embedded Audio / Web Serial GUI', updated: 'Updated Jun 2026',
        url: 'https://github.com/MilanMarocchi/teensy_nam_pedal',
        description: 'Firmware and a browser editor for a Teensy 4.1 amp-modelling pedal running lightweight Neural Amp Modeler captures on Blackaddr audio hardware.',
        visual: 'audio', label: 'NAM'
    },
    {
        title: 'Noise-Robust CAD Conformer', meta: 'Python / Audio ML / Research', updated: 'Updated Feb 2026',
        url: 'https://github.com/MilanMarocchi/noise-robust-cad-conformer',
        description: 'Conformer-based coronary artery disease detection using MFCCs, multichannel heart sounds, and noisy-segment rejection for robustness.',
        visual: 'terminal', label: 'CAD'
    },
    {
        title: 'Wav2Vec Heart Sounds', meta: 'Python / Wav2Vec2 / Biosignals', updated: 'Updated Oct 2025',
        url: 'https://github.com/MilanMarocchi/wav2vec-heart-sounds',
        description: 'Code for dataset augmentation and fine-tuning Wav2Vec 2.0 models for abnormal heart sound classification.',
        visual: 'waveform', label: 'W2V'
    },
    {
        title: 'eqMax', meta: 'C++ / Qt / macOS Audio DSP', updated: 'Pinned on GitHub',
        url: 'https://github.com/MilanMarocchi/eqMax',
        description: 'A macOS system audio equaliser and per-application volume mixer with stereo effects, presets, and real-time spectrum analysis.',
        visual: 'analyzer', label: 'EQ'
    },
    {
        title: 'PodBox', meta: 'C++ / Dear ImGui / macOS', updated: 'Pinned on GitHub',
        url: 'https://github.com/MilanMarocchi/podbox',
        description: 'A standalone music-player manager for macOS to browse libraries, transfer songs, edit metadata, and manage playlists on classic iPods and USB music players.',
        visual: 'audio', label: 'POD'
    }
];
